import { render, staticRenderFns } from "./PreviousList.vue?vue&type=template&id=0cc89d3f"
import script from "./PreviousList.vue?vue&type=script&lang=js"
export * from "./PreviousList.vue?vue&type=script&lang=js"
import style0 from "./PreviousList.vue?vue&type=style&index=0&id=0cc89d3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports